import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1280,
      xl: 1536
    },
  },
  palette: {
    background: {
      default: '#172e38',
      paper: '#172e38',
    },
      text: {
          primary: '#fff',
          secondary: 'rgba(255, 255, 255, 0.6)',
      },
    // blue
    primary: {
      main: '#172e38',
      contrastText: '#FFFFFF',
    },
    // yellow
    secondary: {
      dark: '#172e38',
      main: '#f6ee31',
      light: '#f6ee31',
      contrastText: '#FFFFFF',
    },
    tertiary: {
      main: "#172e38",
      contrastText: '#FFFFFF'
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 30px #172e38 inset !important;
          -webkit-text-fill-color: #ffffff !important;
        }
      `,
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: '#172e38',
          color: '#ffffff',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ffffff',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ffffff',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ffffff',
          },
          '& .MuiInputBase-input::placeholder': {
            color: '#ffffff',
            opacity: 1,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          display: 'none',
        },
      },
    },
    MuiFormHelperText: {
        styleOverrides: {
            root: {
                color: '#ffffff',
            }
        }
    },
    MuiButton: {
        styleOverrides: {
            root: {
                textTransform: 'none',
                backgroundColor: '#fff',
                color:'#000',
            }
        }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
        },
      },
    },
  },
  typography: {
    fontFamily: '"Comfortaa"'
  }
});
// COLOR THEMES HERE primary secondary.light
